import SvgEditIcon from "../../../../../assets/icons/SvgEditIcon1";

  const Productdata = [
    {
      id: 1,
      VoucherNumber: "Voucher0123",
      TransactionNumber: "Trans00123",
      CustomerCode:"Cus01123",
      VoucheDate: "11/12/2023",
      Amount: "500.00",
      action: <SvgEditIcon/>,
      status:"Printed"
    },
    {
      id: 2,
      VoucherNumber: "Voucher0124",
      CustomerCode:"Cus01123",
      TransactionNumber: "Trans00124",
      VoucheDate: "12/12/2023",
      Amount: "600.00",
      action: <SvgEditIcon/>,
      status:'Pending'
    },
    // {
    //   id: 3,
    //   VoucherNumbers: "Voucher0125",
    //   TransactionNumbers: "Trans00125",
    //   CustomerCodes:"Cus01123",
    //   VoucheDates: "13/12/2023",
    //   Amounts: "700.00",
    //   actions: <SvgEditIcon/>,
      
    // },
    // {
    //   id: 4,
    //   VoucherNumbers: "Voucher0126",
    //   TransactionNumbers: "Trans00126",
    //   CustomerCodes:"Cus01123",
    //   VoucheDates: "14/12/2023",
    //   Amounts: "800.00",
    //   actions: <SvgEditIcon/>,
    // },
    // {
    //   id: 5,
    //   VoucherNumber: "Voucher0127",
    //   TransactionNumber: "Trans00127",
    //   VoucheDate: "15/12/2023",
    //   CustomerCode:"Cus01123",
    //   Amount: "900.00",
    //   action: <SvgEditIcon/>,
    // },
    // {
    //   id: 6,
    //   VoucherNumber: "Voucher0128",
    //   TransactionNumber: "Trans00128",
    //   VoucheDate: "16/12/2023",
    //   CustomerCode:"Cus01123",
    //   Amount: "1000.00",
    //   action: <SvgEditIcon/>,
    // },
    // {
    //   id: 7,
    //   VoucherNumber: "Voucher0129",
    //   TransactionNumber: "Trans00129",
    //   VoucheDate: "17/12/2023",
    //   CustomerCode:"Cus01123",
    //   Amount: "1100.00",
    //   action: <SvgEditIcon/>,
    // },
    // {
    //   id: 8,
    //   VoucherNumber: "Voucher0130",
    //   TransactionNumber: "Trans00130",
    //   VoucheDate: "18/12/2023",
    //   CustomerCode:"Cus01123",
    //   Amount: "1200.00",
    //   action: <SvgEditIcon/>,
    // },
    // {
    //   id: 9,
    //   VoucherNumber: "Voucher0131",
    //   TransactionNumber: "Trans00131",
    //   VoucheDate: "19/12/2023",
    //   CustomerCode:"Cus01123",
    //   Amount: "1300.00",
    //   action: <SvgEditIcon/>,
    // },
    // {
    //   id: 10,
    //   VoucherNumber: "Voucher0132",
    //   TransactionNumber: "Trans00132",
    //   VoucheDate: "20/12/2023",
    //   CustomerCode:"Cus01123",
    //   Amount: "1400.00",
    //   action: <SvgEditIcon/>,
    // }
];
export default Productdata
